export const ExplorerLinksList = [
    {
        text: "AES Cloud Ops Commands",
        link: "https://aescloudopstools-mechanic-iad.aka.amazon.com/explorer"
    },
    {
        text: "Tumbler Commands",
        link: "https://api.us-east-2.tumbler.prod.search-services.aws.a2z.com:8443/explorer/"
    }
]